"use strict";

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.array.iterator");

var emptyL = require("../Lazy/emptyL.js");

module.exports = toIter;

function toIter(iterable) {
  return iterable && iterable[Symbol.iterator] ? iterable[Symbol.iterator]() : emptyL();
}